// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"5b44bc81","404":"ff3323c2"}[chunkId] + ".chunk.js";
};